<template>
    <div class="container">
        <div class="topic_title">题目设置</div>
        <el-form ref="form" :model="form" label-width="80px" class="formlist">
            <el-form-item label="题目" class="is-required">
                <el-input v-model="form.question"></el-input>
            </el-form-item>
            <el-form-item label="配图" class="image_box" >
                <!-- <el-upload :class="['app', 'agent'].indexOf(type) >= 0 ? 'avatar-uploader' : 'avatar-uploader' "
                    :action="ossAction" :show-file-list="false" :http-request="uploadOSSRequest"
                    :before-upload="beforeImageUpload">
                    <img v-if="form.img_url" :src="form.img_url"
                        :class="['app', 'agent'].indexOf(type) >= 0 ? 'avatar' : 'product'" />
                    <i v-else :class="['app', 'agent'].indexOf(type) >= 0
                            ? 'el-icon-plus avatar-uploader-icon'
                            : 'el-icon-plus product-uploader-icon'
                        "></i>

                </el-upload>
                <i class="el-icon-delete imagedele" v-if="form.img_url" @click="deleteimageHandel"></i> -->
                
                    <activityCustomUpload :tip="''" :formName="'topic_url'" :formValue="form.img_url"
                    @uploadSuccess="uploadSuccess">
                    </activityCustomUpload>
                
            </el-form-item>
            <div class="option" style="display:flex ; align-items:center">
                <div style="margin-right:50px">选项</div>
                <div>
                    <el-radio-group v-model="radio" @change="checkradio">
                        <el-radio :label="2" :disabled="istrue">单选</el-radio>
                        <el-radio :label="3" :disabled="istrue">多选</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div v-if="radio == 2">
                <el-form-item :label="String.fromCharCode(65 + index)" v-for="(option, index) in form.option" :key="index" class=" is-required">
                    <label class="optionlist">
                        <el-input type="text" v-model="option.answer" :placeholder="'输入测试选项内容 '"
                            style="width: 500px" maxlength="50"></el-input>
                        &nbsp; &nbsp;
                        <el-radio v-model="selectedOptionIndex" :label="index" @change="selectOption(index)" :disabled="istrue">正确答案</el-radio>
                        &nbsp; &nbsp;
                        <i class="el-icon-delete" @click="removeOption(index)" style="color: red; margin-left: 10px"></i>
                    </label>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addOption" :disabled="istrue">添加选项</el-button>
                </el-form-item>
            </div>
            <div v-if="radio == 3">
                <el-form-item :label="String.fromCharCode(65 + index)" v-for="(option, index) in form.option" :key="index" class=" is-required">
                    <label class="optionlist">
                        <el-input type="text" v-model="option.answer" :placeholder="'输入测试选项内容 '"
                            style="width: 500px" maxlength="50"></el-input>
                        &nbsp; &nbsp;
                        <el-checkbox v-model="option.checkistrue" @change="selectcheck(index)" :disabled="istrue">正确答案</el-checkbox>
                        &nbsp; &nbsp;
                        <i class="el-icon-delete" @click="removeOption(index)" style="color: red; margin-left: 10px"></i>
                    </label>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addOption" :disabled="istrue">添加选项</el-button>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>
  
<script>
import {
    beforeImageUpload,
    uploadOSSRequest,
    getAliyunOssToken,
} from "@/api/common";
import { getTestDimensionList } from "@/api/coupon";
import activityCustomUpload from "@/components/activityCustomUpload.vue";
export default {
    data() {
        return {
            form: {
                question: "",
                img_url: "",
                type: "radio",
                option: [
                    {
                        index: 0,
                        answer: "",
                        right: "0",
                        selected: "0",
                        value: String.fromCharCode(65),
                    }, // 分数
                    {
                        index: 1,
                        answer: "",
                        right: "0",
                        selected: "0",
                        value: String.fromCharCode(66),
                    },
                ],
            },
            type: "app",
            radio: "2",
            ossAction: "",
            selectedOptionIndex: null,
            checkistrue: false,
            options2: [
                { value: String.fromCharCode(65), answer: "" },
                { value: String.fromCharCode(66), answer: "" },
            ], // 随机
            options3: [
                {
                    index: 0,
                    answer: "",
                    right: "0",
                    selected: '0',
                    checkistrue: false,
                    value: String.fromCharCode(65),
                },
                {
                    index: 1,
                    answer: "",
                    right: "0",
                    selected: '0',
                    checkistrue: false,
                    value: String.fromCharCode(66),
                },
            ], //维度
            selectList: [
                {
                    id: "选项1",
                    title: "黄金糕",
                },
            ],
            radio: 2,
        };
    },
    components: {
        activityCustomUpload,
    },
    props: ["types", "id", "list", "seleceList", "resultsList","istrue"],
    // created() {
    //     if (this.types == 1) {
    //         this.form.option = this.options2;
    //     } else if (this.types == 3) {
    //         this.form.option = this.options3;
    //     }
    // },
    mounted() {
        setTimeout(() => {
            if (this.list) {
                if (Object.keys(this.list).length !== 0) {
                    this.form = Object.assign({}, this.list);
                }
                if(this.list.type == 'radio'){
                    this.radio = 2
                    this.list.option.forEach((opt, index) => {
                    if (opt.right == "1") {
                        this.selectedOptionIndex = opt.index;
                    }
                });
                }else{
                    this.radio = 3
                    this.list.option.forEach((opt, index) => {
                    if (opt.right == "1") {
                        opt.checkistrue = true;
                    }else{
                        opt.checkistrue = false;
                    }
                });
                }
            }
        }, 1000);
        // this.getTestDimensionListHandel();
        console.log(this.list, 'props: ["types", "id"],');
        console.log(this.radio, "radio:2,");

    },
    methods: {
        selectOption(index) {// 设置选中的选项
            console.log(this.selectedOptionIndex, 'selectedOptionIndex');
            this.form.option.forEach((option, idx) => {
                if (idx == index) {
                    option.right = "1";
                } else {
                    option.right = "0";
                }
            });
        },
        selectcheck(index) {
            this.form.option.forEach((option, idx) => {
                if (option.checkistrue == true) {
                    option.right = "1";
                } else {
                    option.right = "0";
                }
            });

            console.log('this.form.option', this.form.option, index);
        },
        checkradio(value) {
            console.log(value, "checkradio");
            if (value == 3) {
                this.options3.forEach((option, idx) => {
                    option.answer = '';
                    option.selected = "0",
                    option.right= "0"
                    option.checkistrue = false
                });
                console.log(this.options3,'options');
                this.form.option = this.options3;
                this.form.type = "checkbox";
            } else {
                this.form.option.forEach((option, idx) => {
                    option.answer = '';
                    option.selected = "0",
                    option.right= "0"
                });
                this.selectedOptionIndex = null,
                console.log(this.form.option,'option');
                this.form.option = this.form.option;
                this.form.type = "radio";
            }
        },
        deleteimageHandel() {
            // 删除图片
            this.form.img_url = "";
        },
        addOption() {
            // 添加
            if(this.form.option.length <= 25){
                if (this.radio == 2) {
                const newIndex = this.form.option.length; // 获取当前索引
                const option = {
                    index: newIndex,
                    answer: "",
                    right: "0",
                    selected: "0",
                    value: String.fromCharCode(65 + newIndex),
                };
                this.form.option.push(option); // 将选项添加到数组中
            } else {
                const newIndex = this.form.option.length; // 获取当前索引
                const option = {
                    index: newIndex,
                    answer: "",
                    right: "0",
                    selected: '0',
                    checkistrue: false,
                    value: String.fromCharCode(65 + newIndex),
                };
                this.form.option.push(option); // 将选项添加到数组中
            }
            }else{
                this.$message.error("超出限制不可添加");
            }
        },
        removeOption(index) {
            // 删除
            if(!this.istrue){
                if (this.form.option.length > 2) {
                this.form.option.splice(index, 1);
            } else {
                // 如果只剩下两个选项，做相应的处理
                this.$message.error("最少两项，不可删除");
                // 或者你可以写其他的处理逻辑
                return;
            }
            }else{
                return
            }
        },
        getTestDimensionListHandel() {
            let data = {
                test_id: this.id,
            };
            getTestDimensionList(data).then((res) => {
                // console.log(res);
                this.selectList = res.data;
                // console.log(this.seleceList);
            });
        },
        beforeImageUpload(file) {
            beforeImageUpload(file);
        },
        uploadOSSRequest(file) {
            getAliyunOssToken({ dir: "" }).then((res) => {
                uploadOSSRequest(file.file, res.data).then((fileUrl) => {
                    this.form.img_url = fileUrl;
                });
            });
        },
        submitForm() {
            // 通过 $refs.form 获取 el-form 引用，并调用其 validate 方法来校验表单
            return new Promise((resolve, reject) => {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        // 获取表单内容
                        const formData = { ...this.form };
                        resolve(formData); // 返回表单内容
                    } else {
                        reject(new Error("表单校验失败"));
                    }
                });
            });
        },
        uploadSuccess(value) {
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();

            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );
            console.log(isImageFormat,fileExtension,value);

            if (value.type != "delete") {
                if (!isImageFormat) {
                    this.$message({
                        message: "请上传图片格式文件（png, jpeg, jpg, gif）",
                        type: "error",
                    });
                    console.log("1");
                    return;
                }

                // 创建一个图片对象来获取图片尺寸
                const img = new Image();
                img.onload = () => {
                    // 检查图片尺寸是否符合要求
                    if (img.width > 99999 || img.height > 99999) {
                        this.$message({
                            message: "图片尺寸不符，请重新上传",
                            type: "error",
                        });
                        console.log("2");
                        return;
                    }
                    const maxSizeInBytes = 200000 * 1024; // 300KB
                    if (value.file.file.size > maxSizeInBytes) {
                        this.$message({
                            message: "图片大小不符，请重新上传",
                            type: "error",
                        });
                        console.log("3");
                        return;
                    }
                    console.log(img.src, " img.src = value.fileUrl;");
                    // 图片格式、尺寸、大小均符合要求，更新表单数据
                    // this.form[value.formName] =  value.fileUrl;
                    // this.$refs.ruleForm.validateField(value.formName);
                    console.log(value.fileUrl,this.form.img_url);
                };
                // 加载图片以获取其尺寸
                this.form.img_url = img.src = value.fileUrl;
            } else {
                if (isImageFormat) {
                    // console.log('是图片格式');
                    this.form.img_url = value.fileUrl
                    // this.$refs.ruleForm.validateField(value.formName);
                } else {
                    this.$message({
                        message: "请上传图片格式文件",
                        type: "error",
                    });
                    return;
                }
            }
        },
    },
};
</script>
  
<style>
.container {
    padding: 30px;
    box-sizing: border-box;
}

.topic_title,
.option {
    margin-bottom: 20px;
    font-size: 16px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.formlist .avatar {
    width: 178px !important;
    height: 178px;
    display: block;
}

.hides {
    background: #fff;
    width: 100px;
    height: 100px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
}

.product-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 335px;
    height: 144px;
    line-height: 144px;
    text-align: center;
}

.product {
    width: 335px;
    height: 144px;
    display: block;
}

.optionlist {
    display: flex;
    align-items: center;
}

.optionlist .el-input {
    width: 100px;
}

.el-icon-delete {
    cursor: pointer;
}

.el-select .el-input {
    width: 200px !important;
}

.image_box {
    position: relative;
    width: 300px;
}

.imagedele {
    color: red;
    position: absolute;
    top: 45%;
    right: 10%;
}</style>